import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Sos nutricionista graduada o en práctica profesional activa', 'Querés consultar con más orden, criterio y seguridad clínica', 'Buscás un sistema listo para usar, no más contenido para procesar', 'Querés mejorar la calidad de tus consultas sin estudiar años más', 'Trabajás de forma presencial, virtual o en ambas modalidades', 'Querés que tu práctica se vea y se sienta más profesional'];
const notForYou = ['Buscás un curso con clases en video o certificación académica', 'Esperás que alguien te diga exactamente qué decirle a cada paciente', 'No estás dispuesta a invertir en organizar y mejorar tu práctica', 'Querés resultados sin aplicar ningún cambio en tu consultorio'];
export function AudienceSection() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-10" data-mp="3cq0rxzylhdp3">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="3hpdbaaq9c2mx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-sage/20 bg-[#F0F7ED] p-6 sm:p-8" data-id="element-12" data-mp="3hnk5syrdrogi">
          <h3 className="mb-6 text-lg font-bold text-dark-green sm:text-xl" data-id="element-13" data-mp="qje1jide94hs">
            ✅ Este sistema es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="llck11vm9d8f">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="gl82r9mvweh5">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-dark-green" data-id="element-16" data-mp="gjnajqo1l7mg">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="7kjocdtkwc3q" />
                </span>
                <span className="text-sm leading-relaxed text-slate/80" data-id="element-18" data-mp="7mwbr6i3veo6">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-19" data-mp="21yb31rqrlm61">
          <h3 className="mb-6 text-lg font-bold text-slate sm:text-xl" data-id="element-20" data-mp="3mi6gd8unwt52">❌ No es para vos si...</h3>
          <ul className="space-y-4" data-id="element-21" data-mp="3qiqd4bbbpuqo">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="i1vkdoo8pqqb">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-23" data-mp="i0km24dkdb6l">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="928lb9izgx0f" />
                </span>
                <span className="text-sm leading-relaxed text-slate/80" data-id="element-25" data-mp="e0aewoe1ceq5">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}